import React from 'react';
import { Link } from 'react-router-dom';
import { Printer, Users, Coins, Shield, ChevronRight, Database, Coffee, History } from 'lucide-react';

const Settings: React.FC = () => {
  const settingsItems = [
    {
      title: '税制設定',
      description: '消費税率と免税事業者モードの管理',
      icon: Shield,
      path: '/settings/tax',
      color: 'bg-blue-500',
      adminOnly: true
    },
    {
      title: 'プリンター設定',
      description: 'レシートプリンターの設定',
      icon: Printer,
      path: '/settings/printer',
      color: 'bg-green-500',
      adminOnly: false
    },
    {
      title: 'スタッフ管理',
      description: 'スタッフアカウントの管理',
      icon: Users,
      path: '/settings/staff',
      color: 'bg-purple-500',
      adminOnly: true
    },
    {
      title: 'ポイント設定',
      description: 'ポイントシステムの設定',
      icon: Coins,
      path: '/settings/points',
      color: 'bg-yellow-500',
      adminOnly: true
    },
    {
      title: 'バックアップ管理',
      description: 'データバックアップと復元',
      icon: Database,
      path: '/settings/backup',
      color: 'bg-indigo-500',
      adminOnly: true
    },
    {
      title: '弁当メニュー管理',
      description: 'LIFF弁当予約の商品・カテゴリ・画像の編集',
      icon: Coffee,
      path: '/settings/bento-menu',
      color: 'bg-orange-500',
      adminOnly: true
    },
    {
      title: 'ログイン履歴',
      description: '詳細なログイン履歴の確認',
      icon: History,
      path: '/settings/login-history',
      color: 'bg-red-500',
      adminOnly: true
    }
  ];

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-800">設定</h1>
        <p className="text-gray-600 mt-2">システムの各種設定を管理できます</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {settingsItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className="block bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
          >
            <div className="p-6 flex items-center justify-between">
              <div className="flex items-center">
                <div className={`${item.color} p-3 rounded-lg text-white mr-4`}>
                  <item.icon className="w-8 h-8" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-800">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 mt-1">
                    {item.description}
                  </p>
                  {item.adminOnly && (
                    <span className="inline-block mt-2 px-2 py-1 text-xs font-semibold text-orange-600 bg-orange-100 rounded">
                      管理者専用
                    </span>
                  )}
                </div>
              </div>
              <ChevronRight className="w-6 h-6 text-gray-400" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Settings;